import { useEffect, useState } from "react";
import { Route as RouteIcon, CheckCircle2, AlertTriangle, CalendarDays } from "lucide-react";
import api from "@/lib/api";

const TILES = [
  { key: "pending_pickups",     label: "Pending Pick-ups",          sub: "Dispatched / En Route",       Icon: RouteIcon,    testid: "kpi-pending" },
  { key: "completed_pickups",   label: "Completed Pick-ups",        sub: "All time",                    Icon: CheckCircle2, testid: "kpi-completed" },
  { key: "active_complaints",   label: "Active Complaints",         sub: "Pending + In Progress",       Icon: AlertTriangle, testid: "kpi-complaints" },
  { key: "future_reservations", label: "Total Future Reservations", sub: "Confirmed upcoming",          Icon: CalendarDays,  testid: "kpi-future" },
];

export default function OperationsKPIs() {
  const [data, setData] = useState({});
  useEffect(() => {
    const fetch = async () => {
      try { const { data } = await api.get("/admin/metrics/operations"); setData(data); } catch {}
    };
    fetch();
    const id = setInterval(fetch, 20_000);
    return () => clearInterval(id);
  }, []);
  return (
    <div data-testid="operations-kpi-grid" className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      {TILES.map(({ key, label, sub, Icon, testid }) => (
        <div
          key={key}
          data-testid={testid}
          className="backdrop-blur-xl bg-[#121214]/80 border border-white/10 p-6 min-h-[150px] flex flex-col justify-between"
        >
          <div className="flex items-center justify-between">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#8E9AA6]">{label}</div>
            <Icon size={18} strokeWidth={1.5} className="text-[#C5A24A]" />
          </div>
          <div>
            <div className="text-4xl md:text-5xl font-serif font-semibold text-white tracking-tight" data-testid={`${testid}-value`}>
              {data[key] ?? "—"}
            </div>
            <div className="text-[11px] text-[#8E9AA6] tracking-wide mt-2">{sub}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
